import api from '@/helpers/api'
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import { EVENT_CHECKPOINT_ROUTES } from '../router/routes'
import type { FilterType } from '../types/filters/FilterType'
import type { PaginationType } from '../types/PaginationType'
import { buildQueryUrl } from '../utils/queryUtils'

const API_EVENT_PREFIX = (siteId: number) => EVENT_CHECKPOINT_ROUTES.buildUrl(siteId)

const checkpointApi = {
    addCheckpointToEvent: (siteId: number, checkpointData: Partial<CheckpointModel>) =>
        api.post(`${API_EVENT_PREFIX(siteId)}`, checkpointData),
    deleteCheckpointFromEvent: (siteId: number, poiId: number) =>
        api.delete(`${API_EVENT_PREFIX(siteId)}/${poiId}`),
    updateCheckpointFromEvent: (
        siteId: number,
        poiId: number,
        checkpointData: Partial<CheckpointModel>
    ) => api.patch(`${API_EVENT_PREFIX(siteId)}/${poiId}`, checkpointData),

    getCheckpointsFromEvent: (
        siteId: number,
        params?: Partial<PaginationType> & Partial<FilterType<Partial<CheckpointModel>>>,
        noQueryParam?: boolean
    ) =>
        api
            .get(`${API_EVENT_PREFIX(siteId)}${buildQueryUrl(params, noQueryParam)}`)
            .then(res => res.data),
    getSpecificCheckpointFromEvent: (siteId: number, poiId: number) =>
        api.get(`${API_EVENT_PREFIX(siteId)}/${poiId}`),
    associateDeviceToCheckpoint: (siteId: number, poiId: number, device_id: number) =>
        api.post(`${API_EVENT_PREFIX(siteId)}/${poiId}/associate`, { device_id }),
    unassociateDeviceFromCheckpoint: (siteId: number, poiId: number, device_id: number) =>
        api.post(`${API_EVENT_PREFIX(siteId)}/${poiId}/unassociate`, { device_id }),

    eraseDetectionsFromCheckpoint: (siteId: number, poiId: number) =>
        api.delete(`${API_EVENT_PREFIX(siteId)}/${poiId}/detections`)
}

export default checkpointApi
